import * as types from '../mutation-types'
import { api } from '@/modules/api'

const state = {
  vipAttendees: [],
  totalVipAttendeePages: 0,
  totalVipAttendeeItems: 0,
  vipAttendeeStatusesCount: null
}

const getters = {
  vipAttendeeList: state => state.vipAttendees,
  totalVipAttendeePages: state => state.totalVipAttendeePages,
  totalVipAttendeeItems: state => state.totalVipAttendeeItems,
  getVipAttendeeStatusesCount: state => state.vipAttendeeStatusesCount
}

const actions = {
  async getVipAttendeeList ({commit}, payload = {}) {
    try {
      commit(types.SET_SPINNER_STATUS, true)
      const response = await this.$axios.get(api.vipAttendee.getVipAttendee(payload))
      commit(types.SET_VIP_ATTENDEE_LIST, response.data)
    } catch (err) {
      throw err
    } finally {
      commit(types.SET_SPINNER_STATUS, false)
    }
  },
  async editVipAttendee ({commit}, payload) {
    try {
      commit(types.SET_SPINNER_STATUS, true)
      await this.$axios.put(api.vipAttendee.editVipAttendee(), payload)
      commit(types.CREATE_SUCCESS_MESSAGE, 'Attendee was updated!')
    } catch (err) {
      commit(types.CREATE_ERROR_MESSAGE, err.response.data.Message)
      throw err
    } finally {
      commit(types.SET_SPINNER_STATUS, false)
    }
  },
  async fetchVipAttendeeStatusesCount ({commit}) {
    try {
      commit(types.SET_SPINNER_STATUS, true)
      const response = await this.$axios.get(api.vipAttendee.getStatusesCount())
      commit(types.SET_VIP_ATTENDEE_STATUSES_COUNT, response.data)
    } catch (err) {
      commit(types.CREATE_ERROR_MESSAGE, 'Failed to get statuses count')
    } finally {
      commit(types.SET_SPINNER_STATUS, false)
    }
  },
  async changePackageOfVipAttendee ({ commit }, payload) {
    try {
      const response = await this.$axios.put(api.vipAttendee.changePackage(), payload)
      return response
    } catch (err) {
      this.dispatch('showResultErrorMessage', 'Package wasn\'t changed')
      throw err
    }
  }
}

const mutations = {
  [types.SET_VIP_ATTENDEE_LIST] (state, {vipAttendees, totalPages, totalItems}) {
    state.vipAttendees = [...vipAttendees]
    state.totalVipAttendeePages = totalPages
    state.totalVipAttendeeItems = totalItems
  },
  [types.SET_VIP_ATTENDEE_STATUSES_COUNT] (state, data) {
    state.vipAttendeeStatusesCount = data.statusesCount
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/vipAttendee.js